import React from 'react'
import TextField from '@mui/material/TextField'

const FormFloat = ({ label, placeholder, value, required, error, handleChange, fixedWidth }) => {
  return (
    <TextField
      label={label}
      placeholder={placeholder}
      required={required}
      error={error}
      value={value}
      onChange={e => handleChange(e.target.value)}
      variant='outlined'
      pattern="[0-9]*[.,]?[0-9]+"
      InputProps={{
        sx: { borderRadius: '8px', },
      }}
      sx={{ width: fixedWidth ? fixedWidth : '100%' }}
    />
  )
}

export default FormFloat